export default __webpack_public_path__ + "static/media/Himalayas-1.6472cc27.jpg";